import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { contentfulViews } from '@glowforge/ui-common';
import { pagePropType } from 'app/common/selectors/page';

import './reviews.less';

const { Page } = contentfulViews;

const YotpoWidget = () => {
  const yotpoScript = '(function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="https://staticw2.yotpo.com/LkFRBxdJYaHaqTIARYEaUjsuVKBlAoRMqOMvoS81/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();';
  return (
    <div className='YotpoWidget fullWidth'>
      <Helmet>
        <script type='text/javascript'>{yotpoScript}</script>
      </Helmet>
      <div
        className='yotpo yotpo-main-widget'
        data-product-id='generic-GF'
        data-name='Glowforge'
        data-url='https://glowforge.com/order' />
    </div>
  );
};

const ReviewsPage = (props) => {
  const customSections = {
    'yotpo-reviews': {
      component: YotpoWidget,
    },
  };

  return (
    <Page className='Reviews' {...props.page} customSections={customSections} />
  );
};

ReviewsPage.propTypes = {
  page: PropTypes.shape(pagePropType).isRequired,
};

export default ReviewsPage;



// WEBPACK FOOTER //
// ./app/components/product/reviews.jsx